import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectIsMobileMQ } from 'core/modules/MediaQueries/selectors';
import { useGetAllInstoreOffers } from 'core/modules/Instore2/hooks/useGetInstoreOffers';
import PremierMerchantRebate from 'core/modules/PremierMerchantRebate/PremierMerchantRebate';
import MerchantClickUrlLink from 'core/modules/MerchantClickUrlLink/MerchantClickUrlLink';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import { selectEasyLinkSuppression } from 'core/selectors/user';
import { postInstoreCardLink } from 'core/actions/member';
import { clearInstoreLinkFailure } from 'core/modules/Instore2/actions';
import { selectDynamicCardLinksFeedback } from 'core/modules/Instore2/selectors';
import { useApiFeedbackManager } from 'core/hooks/useApiFeedbackManager';
import { InstoreRebate, LinkWarning } from 'core/modules/Instore2/partials';
import InstoreOfferLink from './InstoreOfferLink';
import { HSR_PAGE_INSTORE } from 'core/modules/Instore2/utils/constants';
import orgConfig from 'org/configs/org.config';
import './HybridStoresOffer.scss';

import config from '../configs';

function HybridStoresOffer({ merchant }) {
  const { instoreLabel } = orgConfig;
  const dispatch = useDispatch();
  const { offers: instoreOffers, isLoaded: isInstoreLoaded } = useGetAllInstoreOffers();
  const isMobileMQ = useSelector(selectIsMobileMQ);
  const easyLinkSuppression = useSelector(selectEasyLinkSuppression);
  const dynamicCardLinksFeedback = useSelector(selectDynamicCardLinksFeedback);
  const {
    name, rebate, logoUrls, id: merchantId,
  } = merchant;
  const { rebateOptions } = config;
  const instoreOffer = instoreOffers.find((offer) => offer.carteraMerchantId === merchantId) || {};

  const { clearFeedback, feedbackData } = useApiFeedbackManager({
    data: dynamicCardLinksFeedback,
    callbackAction: clearInstoreLinkFailure,
  });

  const { hasLinkFailedFeedback } = feedbackData;

  const { hasEligibleCards } = instoreOffer;

  useEffect(() => {
    if (!easyLinkSuppression && hasEligibleCards) {
      // autolink offer
      dispatch(postInstoreCardLink(
        instoreOffer.offerId,
        {},
        {},
        { autoLink: true, initiator: HSR_PAGE_INSTORE, offer: instoreOffer },
      ));
    }
  }, [easyLinkSuppression, hasEligibleCards]);

  return (
    <div className="mn_hybridStoresOfferOverlayContent">
      <div className="mn_topSection">
        <h2 id="mn_dialogTitle">Shop online or {instoreLabel}</h2>
        <img src={logoUrls._120x60} alt={name} />
      </div>
      <hr />
      <div className="mn_bottomSection" id="mn_dialogDescription">
        <LinkWarning hasError={hasLinkFailedFeedback} />
        <div className="mn_onlineOffer">
          <div className="mn_offerDetails">
            Online offer:&nbsp;
            <PremierMerchantRebate {...rebate} {...rebateOptions} />
          </div>
          <MerchantClickUrlLink merchant={merchant}>
            <button className="mn_button mn_secondaryButton">Shop now</button>
          </MerchantClickUrlLink>
        </div>
        {isMobileMQ && <hr />}
        <div className="mn_instoreOffer">
          <div className="mn_offerDetails">
            In-store offer:&nbsp;
            <InstoreRebate offer={instoreOffer} />
          </div>
          <InstoreOfferLink
            instoreOffer={instoreOffer}
            isInstoreLoaded={isInstoreLoaded}
            clearFeedback={clearFeedback}
          />
        </div>
      </div>
      {isMobileMQ && <hr />}
    </div>
  );
}

export default (props) => <ComponentErrorBoundary><HybridStoresOffer {...props} /></ComponentErrorBoundary>;
